import {ref, watch} from 'vue';

export enum ExportType {
	// SINGLE_HTML_FILE = 'single html file',
	SELF_CONTAINED_SCENE = 'self contained scene',
	OPTIMIZED = 'optimized',
}
interface ExportFormData {
	exportType: ExportType;
}
// type LocalStorageData = Partial<ExportFormData>;
const LOCAL_STORAGE_KEY = 'EditorSceneExportFormControllerClass';

type SceneExportFormCallback = (args: ExportFormData) => void;

export class EditorSceneExportFormontrollerClass {
	private static _instance: EditorSceneExportFormontrollerClass;
	static instance() {
		return (this._instance = this._instance || new EditorSceneExportFormontrollerClass());
	}

	private constructor() {
		const saveToLocalStorage = this._saveToLocalStorage.bind(this);
		watch(this._exportType, saveToLocalStorage);
	}

	private _displayed = ref(false);
	private _exportType = ref(ExportType.OPTIMIZED);
	private _resolve: SceneExportFormCallback | undefined;
	// init() {
	// 	// this._displayed
	// 	// const saved = this._loadLocalStorage();
	// 	// this._exportType = ref(saved?.exportType || ExportType.OPTIMIZED);
	// 	// this._exportType

	// }

	// getters
	displayed() {
		return this._displayed.value;
	}
	exportType() {
		return this._exportType.value;
	}

	// mutations
	display(): Promise<ExportFormData> {
		this._displayed.value = true;
		return new Promise((resolve) => {
			this._resolve = resolve;
		});
	}
	confirm() {
		if (this._resolve) {
			this._resolve(this._data());
		}
		this._close();
	}
	cancel() {
		this._close();
		this._resolve = undefined;
	}
	private _close() {
		this._displayed.value = false;
	}
	setExportType(type: ExportType): void {
		this._exportType.value = type;
	}
	private _data(): ExportFormData {
		return {
			exportType: this._exportType.value,
		};
	}

	private _saveToLocalStorage() {
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this._data()));
	}
	// private _loadLocalStorage() {
	// 	const content = localStorage.getItem(LOCAL_STORAGE_KEY);
	// 	if (!content) {
	// 		return;
	// 	}
	// 	try {
	// 		const json = JSON.parse(content) as LocalStorageData;
	// 		return json;
	// 	} catch (e) {
	// 		return;
	// 	}
	// }
}

export const ExportFormWeb = EditorSceneExportFormontrollerClass.instance();
